import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css, keyframes } from 'styled-components';
import { COLORS } from '../utils/styled';
const rotate = keyframes `
    100% {
        transform: rotate(360deg);
    }
`;
function UnstyledSpinner({ coverage = 0.6, fixed = false, color = 'green', size: sizeProp = 16, strokeWidth = 2, innerRef, ...props }) {
    const size = sizeProp === 'medium' ? 22 : sizeProp === 'large' ? 40 : sizeProp;
    const r = (size - strokeWidth) / 2;
    const d = 2 * Math.PI * r;
    const [ringColor, strokeColor] = (() => {
        switch (color) {
            case 'green':
                return [COLORS.SpinnerBorder, COLORS.GreenSpinner];
            case 'blue':
                return [COLORS.SpinnerBorder, COLORS.BlueSpinner];
            case 'white':
                return [COLORS.SpinnerBorder, COLORS.WhiteSpinner];
            case 'gray':
                return [COLORS.White, COLORS.SpinnerBorder];
        }
        const { ring, stroke } = color;
        return [ring, stroke];
    })();
    return (_jsx(SpinnerRoot, { ...props, "$animate": !fixed, ref: innerRef, style: {
            width: `${size}px`,
            height: `${size}px`,
        }, children: _jsxs("svg", { viewBox: `0 0 ${size} ${size}`, role: "img", "aria-label": "Loading", children: [_jsx("circle", { cx: size / 2, cy: size / 2, r: r, fill: "none", strokeWidth: strokeWidth, stroke: ringColor, strokeLinecap: "round", strokeDasharray: `${d}, 0`, strokeDashoffset: "0" }), _jsx("circle", { cx: size / 2, cy: size / 2, r: r, fill: "none", strokeWidth: strokeWidth, stroke: strokeColor, strokeLinecap: "round", strokeDasharray: `${coverage * d}, ${(1 - coverage) * d}`, strokeDashoffset: "0" })] }) }));
}
const SpinnerRoot = styled.div `
    svg {
        display: block;
        transform: rotate(-90deg);
    }

    ${({ $animate = false }) => $animate &&
    css `
            svg {
                animation: ${rotate} 1.1s linear infinite;
                transform: rotate(0);
            }
        `}
`;
const Spinner = styled(UnstyledSpinner) ``;
export default Spinner;
